import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Currency, Marketplace } from "@front/m19-api-client";
import { ProductGridData } from "@front/m19-grid-config";
import { MODAL_DATA } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { ProductViewComponent } from "@m19-board/product-view/product-view.component";
import { ProfitDetailsService } from "@m19-board/services/profit-details.service";
import { ProfitDetailsLineComponent } from "./profit-details-line.component";

export interface ProfitDetailsModalData {
  asin?: string;
  marketplace: Marketplace;
  data: ProductGridData;
  locale: string;
  currency: Currency;
}

@Component({
  selector: "app-profit-details",
  templateUrl: "./profit-details.component.html",
  imports: [TranslocoDirective, ProductViewComponent, ProfitDetailsLineComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfitDetailsComponent {
  protected readonly modalData = inject<ProfitDetailsModalData>(MODAL_DATA);
  private readonly profitDetailsService = inject(ProfitDetailsService);

  protected readonly profitLines = this.profitDetailsService.getAllProfitLines(
    this.modalData.data,
    this.modalData.locale,
    this.modalData.currency,
  );
}
